import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { scrollUp } from 'core/utils/animations';
import { EXTERNAL_LINK_PROPS } from 'core/utils/link';
import { configuration } from 'config/constants';
import { RoutePaths, SearchCategoryEnum } from 'routes/RoutePaths';
import { useAppSelector } from 'store/store';

type SeeMoreLinkProps = {
    to: SearchCategoryEnum;
    total: number;
    openInNew?: boolean;
};

export const SeeMoreLink: React.FC<SeeMoreLinkProps> = ({
    to,
    total,
    openInNew,
}) => {
    const { t: translate } = useTranslation('service-list');
    const searchTerm = useAppSelector(state => state.search.searchTerm);

    const onClickSeeMore = () => {
        scrollUp();
    };

    return <p className="text-end mt-2">
        <Link
            to={RoutePaths.Search.url(searchTerm ?? '', to ?? SearchCategoryEnum.All)}
            onClick={onClickSeeMore}
            {...(openInNew && EXTERNAL_LINK_PROPS)}
        >
            {translate('service-list:seeAll', { total })}{' '}
            <i className="icon icon-sm">arrow_forward</i>
        </Link>
    </p>;
};

export const SeeMoreLinkSgm: React.FC<Omit<SeeMoreLinkProps, 'to'>> = ({ total, openInNew }) => {
    return <SeeMoreLink
        to={SearchCategoryEnum.SgMarkets}
        total={total}
        openInNew={openInNew}
    />;
};

export const SeeMoreLinkOnIc: React.FC = () => {
    const searchTerm = useAppSelector(state => state.search.searchTerm);

    const { t: translate } = useTranslation('service-list');
    const { seeAllInIc } = configuration;

    const onClickSeeMore = () => {
        scrollUp();
    };
    return (
        <p className="text-end mt-2">
            <a
                href={seeAllInIc.replace('{0}', searchTerm ?? '')}
                onClick={onClickSeeMore}
                {...EXTERNAL_LINK_PROPS}
            >
                {translate('service-list:seeAllInIc')}
                <i className="icon icon-sm">arrow_forward</i>
            </a>
        </p>
    );
};

export const SeeMoreLinkSgAll: React.FunctionComponent<Omit<SeeMoreLinkProps, 'to'>> = ({ total, openInNew }) => {
    return (
        <SeeMoreLink
            to={SearchCategoryEnum.Societe}
            total={total}
            openInNew={openInNew}
        />
    );
};

export const SeeMoreLinkPerson: React.FunctionComponent<Omit<SeeMoreLinkProps, 'to'>> = ({ total, openInNew }) => {
    return (
        <SeeMoreLink
            to={SearchCategoryEnum.Person}
            total={total}
            openInNew={openInNew}
        />
    );
};

export const SeeMoreLinkCompany: React.FunctionComponent<Omit<SeeMoreLinkProps, 'to'>> = ({ total, openInNew }) => {
    return (
        <SeeMoreLink
            to={SearchCategoryEnum.Company}
            total={total}
            openInNew={openInNew}
        />
    );
};
